import { render, staticRenderFns } from "./addEditblog.vue?vue&type=template&id=6d506148&scoped=true&"
import script from "./addEditblog.vue?vue&type=script&lang=js&"
export * from "./addEditblog.vue?vue&type=script&lang=js&"
import style0 from "./addEditblog.vue?vue&type=style&index=0&id=6d506148&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d506148",
  null
  
)

export default component.exports